exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".transport-table-container {\n  width: 100%;\n  overflow-x: auto;\n  -webkit-overflow-scrolling: touch;\n  margin-top: 16px; }\n\n.transport-table-container mat-table {\n  min-width: 960px; }\n\n@media (max-width: 768px) {\n  .transport-table-container mat-table {\n    min-width: 720px; } }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/TransportModule/TransportComponent/transport.component.scss
// module id = ../../../../../src/TransportModule/TransportComponent/transport.component.scss
// module chunks = main